module.exports = __webpack_public_path__ + "70a47eede02a7f19435d602e2294eb8b.svg";